
import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';


var styles = {
  actionButton: {
    textTransform: 'uppercase',
    marginBottom: '0.5rem',
    paddingLeft: 0,
    fontSize: '1.2rem',
    color: colors.green[600]
  },
  guidelinesWrapper: function guidelinesWrapper(props) {return {
      backgroundColor: props.showGuidelines ? colors.neutral[100] : 'transparent',
      padding: props.showGuidelines ? '0.8rem 1.2rem' : '0',
      borderRadius: '0.6rem',
      fontSize: '1.2rem',
      maxWidth: 'fit-content',
      marginTop: props.showGuidelines ? '1rem' : 0,
      marginBottom: props.showGuidelines && props.type === 'QUESTION' ? '2rem' : 0,
      width: props.width ? props.width : 'auto'
    };},
  simpleGuidelineWrapper: function simpleGuidelineWrapper() {return {
      backgroundColor: 'transparent',
      padding: 0,
      margin: 0,
      '& button': {
        textTransform: 'none'
      }
    };},
  guidelinesText: {
    lineHeight: '1.7rem',
    margin: 0
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map